module.exports = __webpack_public_path__ + "img/IMG_1962_P_Black.7238ae7b.jpg";